/* eslint-disable no-unused-vars, react/prop-types, consistent-return */
import { isEmpty, range } from 'ramda';
import React, { memo } from 'react';

import Circle from './Circle';
import { fadeInClassName, DEFAULT_BORDER_COLOR } from './style';

function SvgRoadmap({
  rows = 5,
  columns = 20,
  items = [],
  colorsMap = {},
  borderColor = DEFAULT_BORDER_COLOR,
  ...props
}) {
  const innerWidth = Math.max(Math.ceil(items.length / rows) + 1, columns);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${columns} ${rows}`}
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${innerWidth} ${rows}`}
        height={rows}
        width={innerWidth}
        x={columns - innerWidth}
      >
        <rect x="0" y="0" width={innerWidth} height={rows} fill="transparent" />
        {range(0, rows + 1).map((r, idx) => (
          <line
            key={`${r}_${idx}`}
            x1="0"
            x2={innerWidth}
            y1={!r ? 0.025 : r === rows ? r - 0.025 : r}
            y2={!r ? 0.025 : r === rows ? r - 0.025 : r}
            stroke={borderColor}
            style={{ strokeWidth: 0.05 }}
          />
        ))}
        {range(0, innerWidth + 1).map((c, idx) => (
          <line
            key={`${c}_${idx}`}
            x1={!c ? 0.025 : c === innerWidth ? c - 0.025 : c}
            x2={!c ? 0.025 : c === innerWidth ? c - 0.025 : c}
            y1="0"
            y2={rows}
            stroke={borderColor}
            style={{ strokeWidth: 0.05 }}
          />
        ))}
        {items.map((item, i) => (
          <Circle
            coordinates={[ i % rows, Math.floor(i / rows) ]}
            key={`${item.roundId}_${i}`}
            className={fadeInClassName}
            fill={!isEmpty(colorsMap) ? colorsMap[item.WinningHand] : undefined}
          />
        ))}
      </svg>
    </svg>
  );
}

export default memo(SvgRoadmap);
